"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _Popover = _interopRequireDefault(require("../../Popover"));

var _Button = _interopRequireDefault(require("../Button"));

var _dynamicModifiers = require("../../../utils/dynamicModifiers");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var PopoverChild = _styledComponents.default.div.withConfig({
  displayName: "Menu__PopoverChild",
  componentId: "sc-1vex4dm-0"
})(["", ";"], (0, _dynamicModifiers.applyDynamicModifiers)('minWidth', 'min-width'));

function Menu(_ref, ref) {
  var childMinWidth = _ref.childMinWidth,
      children = _ref.children,
      counter = _ref.counter,
      disabled = _ref.disabled,
      emblem = _ref.emblem,
      popoverRef = _ref.popoverRef,
      primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      tooltipText = _ref.tooltipText,
      rest = _objectWithoutProperties(_ref, ["childMinWidth", "children", "counter", "disabled", "emblem", "popoverRef", "primaryText", "secondaryText", "tooltipText"]);

  var _useBreakpointObserve = (0, _breakpointObserver.useBreakpointObserver)(),
      _useBreakpointObserve2 = _slicedToArray(_useBreakpointObserve, 2),
      resizeRef = _useBreakpointObserve2[0],
      dimensions = _useBreakpointObserve2[1].dimensions;

  return _react.default.createElement(_Popover.default, _extends({}, rest, {
    borderRadius: "0 0 2px 2px",
    placement: "bottom-end",
    ref: popoverRef,
    showArrow: false,
    target: function target(_ref2) {
      var ariaAttributes = _ref2.ariaAttributes,
          isVisible = _ref2.isVisible,
          targetRef = _ref2.ref,
          toggle = _ref2.toggle;
      return _react.default.createElement(_Button.default, _extends({
        disabled: disabled,
        emblem: emblem,
        expanded: isVisible,
        onClick: toggle,
        primaryText: primaryText,
        ref: (0, _composeReactRefs.default)(ref, resizeRef, targetRef),
        secondaryText: secondaryText,
        tooltipText: tooltipText,
        counter: counter,
        withExpander: true
      }, ariaAttributes));
    }
  }), _react.default.createElement(PopoverChild, {
    minWidth: childMinWidth || (0, _rem.default)((dimensions.width || 0) + 28)
  }, children));
}

var _default = (0, _react.forwardRef)(Menu);

exports.default = _default;